import React, { useState, useEffect } from "react";

const AdminChange = () => {
  const [activeTab, setActiveTab] = useState("hlaska");
  const [hlaska, setHlaska] = useState("");
  const [selectedDay, setSelectedDay] = useState("Pondeli");
  const [dayMenu, setDayMenu] = useState("");
  const [soups, setSoups] = useState("");
  const [sides, setSides] = useState("");
  const [notes, setNotes] = useState("");
  const [pdfFile, setPdfFile] = useState(null);

  const days = ["Pondeli", "Utery", "Streda", "Ctvrtek", "Patek"];

  useEffect(() => {
    fetch("/documents/hlaska.json")
      .then(res => res.json())
      .then(data => setHlaska(data.text || ""));

      fetch("/documents/prilohy.json")
      .then(res => res.json())
      .then(data => {
        setSides((data.sides || []).join("\n"));
        setNotes((data.poznamky || []).join("\n"));
      });
  }, []);

  useEffect(() => {
    fetch(`/documents/${selectedDay.toLowerCase()}.json`)
      .then(res => res.json())
      .then(data => setDayMenu((data.menu || []).join("\n")))
      .catch(() => setDayMenu(""));
  }, [selectedDay]);

  const handleUpload = () => {
    if (!pdfFile) return alert("Vyberte PDF soubor.");
    const formData = new FormData();
    formData.append("menu", pdfFile);
    fetch("/api/upload_pdf.php", { method: "POST", body: formData })
      .then((res) => res.text())
      .then(() => alert("PDF nahráno."))
      .catch(() => alert("Chyba při nahrávání PDF."));
  };

  const saveHlaska = () => {
    fetch("/api/save_alert.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: hlaska })
    }).then(() => alert("Hláška uložena."));
  };

  const saveDay = () => {
    fetch(`/api/save_day.php?day=${selectedDay}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ menu: dayMenu.split("\n") })
    }).then(() => alert(`Menu pro ${selectedDay} uloženo.`));
  };

  const savePrilohy = () => {
    fetch("/api/save_prilohy.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sides: sides.split("\n"),
        poznamky: notes.split("\n")
      })
    }).then(() => alert("Přílohy uloženy."));
  };

  return (
    <div className="max-w-3xl mx-auto py-10 px-4">
      <h1 className="text-3xl font-bold text-orange-700 mb-6 text-center">Admin sekce</h1>
      <div className="flex space-x-4 mb-6 justify-center">
        {["hlaska", "denni", "prilohy", "pdf"].map((key) => (
          <button
            key={key}
            onClick={() => setActiveTab(key)}
            className={`px-4 py-2 rounded ${
              activeTab === key
                ? "bg-red-600 text-white"
                : "bg-orange-100 text-orange-700"
            }`}
          >
            {key === "hlaska"
              ? "Hláška"
              : key === "denni"
              ? "Denní menu"
              : key === "prilohy"
              ? "Polévky & Přílohy"
              : "PDF Menu"}
          </button>
        ))}
      </div>

      {activeTab === "hlaska" && (
        <div>
          <label className="block font-semibold mb-2">Změnit hlášku:</label>
          <input
            value={hlaska}
            onChange={(e) => setHlaska(e.target.value)}
            className="w-full border p-2 rounded"
            placeholder="Např. Dnes zavřeno."
          />
          <button
            onClick={saveHlaska}
            className="mt-4 bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700"
          >
            Uložit hlášku
          </button>
        </div>
      )}

      {activeTab === "denni" && (
        <div>
          <label className="block font-semibold mb-2">Vyber den:</label>
          <select
            value={selectedDay}
            onChange={(e) => setSelectedDay(e.target.value)}
            className="mb-4 p-2 border rounded"
          >
            {days.map((d) => (
              <option key={d} value={d}>{d}</option>
            ))}
          </select>
          <textarea
            value={dayMenu}
            onChange={(e) => setDayMenu(e.target.value)}
            className="w-full h-40 p-2 border rounded"
            placeholder="1. Kuřecí korma\n2. Čočka na kari"
          />
          <button
            onClick={saveDay}
            className="mt-4 bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700"
          >
            Uložit denní menu
          </button>
        </div>
      )}

{activeTab === "prilohy" && (
  <div>
    <label className="block font-semibold mb-2">Přílohy (každý řádek samostatná příloha):</label>
    <textarea
      value={sides}
      onChange={(e) => setSides(e.target.value)}
      className="w-full h-32 p-2 border rounded mb-4"
    />

    <label className="block font-semibold mb-2">Poznámky:</label>
    <textarea
      value={notes}
      onChange={(e) => setNotes(e.target.value)}
      className="w-full h-24 p-2 border rounded mb-4"
    />

    <button
      onClick={savePrilohy}
      className="bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700"
    >
      Uložit přílohy
    </button>
  </div>
)}

      {activeTab === "pdf" && (
        <div>
          <label className="block font-semibold mb-2">Nahrát nové PDF menu:</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setPdfFile(e.target.files[0])}
            className="mb-4"
          />
          <button
            onClick={handleUpload}
            className="bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700"
          >
            Nahrát PDF
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminChange;